// Explore-stats page: Leaders of the Opposition.
// Recreates the Handbook page — Opposition Leaders by party & cumulative
// length of service, number by party, and a name/party/period table.

import React, { useState, useEffect } from 'react';
import { Paper, Typography, Grid } from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';
import { StatBar } from './charts';

export default function OppositionLeaders() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getExploreStat('opposition-leaders');
        if (active) setData(res);
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const c = data?.charts || {};

  return (
    <ExploreStatsPage
      title="Leaders of the Opposition"
      description={`Leaders of the Opposition${
        c.total ? ` (${c.total})` : ''
      } — they rarely last longer than five years; the chart also draws attention to short-serving leaders.`}
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="opposition-leaders"
    >
      {data && (
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
              <Typography variant="h6" sx={{ mb: 1 }}>
                Leaders of the Opposition by party and length of service (years)
              </Typography>
              <StatBar data={c.by_party_service || []} xKey="party"
                       yKey="years" layout="vertical" height={340} />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
              <Typography variant="h6" sx={{ mb: 1 }}>
                Number of Leaders of the Opposition by party
              </Typography>
              <StatBar data={c.count_by_party || []} xKey="party"
                       yKey="count" layout="vertical" height={340} />
            </Paper>
          </Grid>
        </Grid>
      )}
    </ExploreStatsPage>
  );
}
